import {
  CLEAR_OCR,
  UPLOAD_OCR_DOCUMENT_FAILURE,
  UPLOAD_OCR_DOCUMENT_REQUEST,
  UPLOAD_OCR_DOCUMENT_SUCCESS,
  UPLOAD_BATTERY_MODULE_PHOTO_FAILURE,
  UPLOAD_BATTERY_MODULE_PHOTO_REQUEST,
  UPLOAD_BATTERY_MODULE_PHOTO_SUCCESS,
} from "actions/ocr";

const initialState = {
  loading: false,
  uploadDetails: undefined,
  batteryModulePhotoLoading: false,
  batteryModulePhotoDetails: undefined,
};

export default function ocr(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPLOAD_OCR_DOCUMENT_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case UPLOAD_OCR_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        uploadDetails: payload,
      };
    }

    case UPLOAD_OCR_DOCUMENT_FAILURE: {
      return {
        ...state,
        loading: false,
        uploadDetails: undefined,
      };
    }

    case CLEAR_OCR: {
      return {
        ...state,
        ...initialState,
      };
    }

    case UPLOAD_BATTERY_MODULE_PHOTO_REQUEST: {
      return {
        ...state,
        batteryModulePhotoLoading: true,
      };
    }

    case UPLOAD_BATTERY_MODULE_PHOTO_SUCCESS: {
      return {
        ...state,
        batteryModulePhotoLoading: false,
        batteryModulePhotoDetails: payload,
      };
    }

    case UPLOAD_BATTERY_MODULE_PHOTO_FAILURE: {
      return {
        ...state,
        batteryModulePhotoLoading: false,
        batteryModulePhotoDetails: undefined,
      };
    }

    default:
      return state;
  }
}
